import axios from "axios";
import {
    ADD_NEW_USER_EXPERIENCE,
    DELETE_USER_EXPERIENCE,
    UPDATE_USER_EXPERIENCE,
} from "./RestCatalog";


const addNewUserExperience = (payload) => {
    return axios.post(ADD_NEW_USER_EXPERIENCE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const deleteUserExperience = (payload) => {
    return axios.post(DELETE_USER_EXPERIENCE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const updateUserExperience = (payload) => {
    return axios.post(UPDATE_USER_EXPERIENCE, payload)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export { addNewUserExperience, deleteUserExperience, updateUserExperience };

